import { createActionGroup, props } from '@ngrx/store';

import { WorkSaveStatus } from '@ninety/platform/models/_shared/work-save-status';

export const WorkSaveStatusActions = createActionGroup({
  source: 'Work Save Status',
  events: {
    'Component Registered': props<{ id: string; component: string; feature?: string }>(),
    'Status Changed': props<{ id: string; status: WorkSaveStatus | null }>(),
    'Component Unregistered': props<{ id: string }>(),
  },
});
